<template>
  <div>
    <v-text-field
      v-model="currentValue"
      v-show="!hiddenField(access)"
      v-mask="currentMask()"
      autocomplete="off"
      :id="id"
      :label="label"
      :type="fieldTextType(dataType)"
      :required="requiredField(access) && emptyString(browseHelp)"
      :readonly="readonlyField(access) || notBlank(browseHelp)"
      :prefix="prefix"
      :suffix="suffix"
      :progress="toAssign"
      :filled="readonlyField(access) || queryFlag"
      :rules="rules"
      :append-icon="appendIcon()"
      :append-outer-icon="appendOuterIcon()"
      :maxLength="maxLength()"
      :minLength="minLength()"
      :outlined="queryFlag"
      :single-line="queryFlag"
      :hide-details="queryFlag"
      :dense="queryFlag"
      :hint="hint"
      :class="
        dynamicClass({
          type: 'text',
          customStyle,
          queryFlag,
          readonly: readonlyField(access),
        })
      "
      :style="dynamicStyle({ customStyle })"
      @input="() => handleChange(null)"
      @keydown="(k) => handleKeyDown(k, id)"
      @click:append-outer="appendOuterClick()"
      @blur="handleBlur"
      @focus="handleFocus"
    />
  </div>
</template>

<script>
export default {
  name: "TextField",
  props: [
    "label",
    "value",
    "access",
    "customStyle",
    "dataType",
    "id",
    "name",
    "prefix",
    "suffix",
    "toAssign",
    "rules",
    "foreignKey",
    "browseHelp",
    "inputFields",
    "mask",
    "length",
    "secLength",
    "upperLower",
    "queryFlag",
    "coordinates",
    "hint",
    "index",
    "fillTo",
    "filler"
  ],
  data() {
    return {
      defaultValue: this.value,
      currentValue: this.value,
      unmaskedValue: this.value,
      //autoSource: null,
    };
  },
  methods: {
    handleChange(autoSource) {
      if (this.upperLower && this.currentValue) {
        switch (this.upperLower) {
          case "upper": {
            this.currentValue = this.currentValue.toUpperCase();
            break;
          }
          case "lower": {
            this.currentValue = this.currentValue.toLowerCase();
            break;
          }
          case "firstUpper": {
            const firstLetStr =
              this.currentValue.length > 0
                ? this.currentValue.substring(0, 1).toUpperCase()
                : "";
            const remLetStr =
              this.currentValue.length > 1
                ? this.currentValue.substring(1)
                : "";
            this.currentValue = firstLetStr + remLetStr;
            break;
          }
        }
      }
      let definitive = this.currentValue;
      const data = {
        value: definitive,
        id: this.id,
        autoSource, //: this.autoSource,
        coordinates: this.coordinates,
      };
      this.$emit("field-change", data);
    },
    handleKeyDown(key, id) {
      if (this.notBlank(this.foreignKey)) {
        if (key.key.toLowerCase() == "enter") {
          this.doForeignKey();
        }
      } else {
        this.$emit("handle-key-down", key.key, id);
      }
    },
    handleBlur() {
      if (this.notBlank(this.foreignKey)) {
        this.doForeignKey();
      }
      if (this.fillTo && this.filler && this.currentValue) {
        switch (this.fillTo) {
          case 'left': {
            this.currentValue = this.filler.repeat(this.length - this.currentValue.length) + this.currentValue;
            break;
          }
          case 'right': {
            this.currentValue = this.currentValue + this.filler.repeat(this.length - this.currentValue.length);
            break;
          }
          default:
            break;
        }
        this.handleChange();
      }
    },
    handleFocus() {
    },
    appendIcon() {
      if (this.notBlank(this.foreignKey)) {
        if (this.currentValue) {
          return "mdi-check-circle-outline";
        } else {
          return "mdi-dots-horizontal-circle-outline";
        }
      }
    },
    appendOuterIcon() {
      if (this.notBlank(this.browseHelp) && !this.readonlyField(this.access)) {
        return "mdi-magnify";
      }
    },
    doBrowseHelp() {
      this.$emit("handle-browse-help", {
        id: this.id,
        value: this.value,
        transactionName: this.browseHelp,
      });
    },
    doForeignKey() {
      if(!this.readonlyField(this.access)) {
        this.$emit("handle-foreign-key", {
          id: this.id,
          value: this.value,
          transactionName: this.foreignKey,
          index: this.index,
        });
      }
    },
    setValue(value, autoSource) {
      this.currentValue = value;
      //this.autoSource = autoSource;
      this.handleChange(autoSource);
    },
    currentMask() {
      const result = this.okMask() ? this.mask : null;
      return result;
    },
    okMask() {
      return this.mask// && !this.fieldReal(this.dataType);
    },
    //okNumberMask() {
      //return this.fieldReal(this.dataType);
    //},
    maxLength() {
      let result = this.length;
      /*
      if (this.fieldReal(this.dataType)) {
        result =
          (this.length ? this.length : 3) +
          (this.secLength ? this.secLength : 0) +
          (this.secLength ? 1 : 0);
      } else if (this.fieldInteger(this.dataType)) {
        result = this.length;
      }
      */
      return result;
    },
    minLength() {
      return !this.fieldTextType(this.dataType) != "number"
        ? this.secLength
        : null;
    },
    appendOuterClick() {
      if (this.notBlank(this.browseHelp)) {
        this.$emit("handle-browse-help", {
          id: this.id,
          value: this.value,
          transactionName: this.browseHelp,
          index: this.index,
        });
      }
    }
  },
  updated() {},
  mounted() {},
};
</script>

<style scoped>
.query-flag {
  font-size: 0.9em;
}

.custom-text-style >>> .v-text-field__slot label {
  color: var(--label-color);
  background-color: var(--label-background-color);
  font-size: var(--label-size);
  border: var(--label-border);
  border-radius: var(--label-border-radius);
}
.custom-text-style >>> .v-text-field__slot input {
  color: var(--input-color);
  background-color: var(--input-background-color);
  font-size: var(--input-size);
  border: var(--input-border);
  border-radius: var(--input-border-radius);
}
.custom-text-style >>> .v-text-field__slot .v-text-field__prefix {
  color: var(--prefix-color);
  background-color: var(--prefix-background-color);
  font-size: var(--prefix-size);
  border: var(--prefix-border);
  border-radius: var(--prefix-border-radius);
}
.custom-text-style >>> .v-text-field__slot {
  color: var(--slot-color);
  background-color: var(--slot-background-color);
  font-size: var(--slot-size);
  padding: var(--slot-padding);
  margin: var(--slot-margin);
  border: var(--slot-border);
  border-radius: var(--slot-border-radius);
}

.custom-text-style {
  color: var(--field-color);
  background-color: var(--field-background-color);
  font-size: var(--field-size);
  padding: var(--field-padding);
  margin: var(--field-margin);
  border: var(--field-border);
  border-radius: var(--field-border-radius);
}
</style>